import Vue from 'vue'

import router from './router'
import store from './store'

import './filters'
import './directives'
import './plugins/i18n'
import './plugins/bootstrap'
import './styles/common.scss'

import App from './App.vue'

Vue.config.productionTip = false

new Vue({
	router,
	store,
	watch: {
		'$i18n.locale': {
			immediate: true,
			handler() {
				document.title = this.$i18n.gettext('My shopping cart')
			},
		},
	},
	render: h => h(App),
}).$mount('#basket-app')
